import { render, staticRenderFns } from "./slisd.vue?vue&type=template&id=28441d4c&scoped=true"
import script from "./slisd.vue?vue&type=script&lang=js"
export * from "./slisd.vue?vue&type=script&lang=js"
import style0 from "./slisd.vue?vue&type=style&index=0&id=28441d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28441d4c",
  null
  
)

export default component.exports